import { render, staticRenderFns } from "./base_Fgrid_maub.vue?vue&type=template&id=93386d6a"
import script from "./base_Fgrid_maub.vue?vue&type=script&lang=js"
export * from "./base_Fgrid_maub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports